import { render } from "./NavigationCard.vue?vue&type=template&id=ab6c55fa"
import script from "./NavigationCard.vue?vue&type=script&lang=js"
export * from "./NavigationCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__